import { render, staticRenderFns } from "./SidemenuInformationPanel.vue?vue&type=template&id=7bcffa8a&scoped=true&lang=pug&"
import script from "./SidemenuInformationPanel.vue?vue&type=script&lang=ts&"
export * from "./SidemenuInformationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SidemenuInformationPanel.vue?vue&type=style&index=0&id=7bcffa8a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcffa8a",
  null
  
)

export default component.exports